import { useContext } from "react";

import { ISessionContextValue, SessionContext } from "../../session";

export const useSession = (): ISessionContextValue => {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error("useSession must be used inside a SessionProvider");
  }

  return context;
};
